function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState } from 'react';
import { Input } from '@keen.io/ui-core';
import { useOnClickOutside } from '@keen.io/react-hooks';
import { FilterSuggestions } from '../FilterSuggestions';
import { FilterStringWrapper } from './FilterString.styles';

var FilterString = function FilterString(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      stringPlaceholder = _ref.stringPlaceholder,
      suggestions = _ref.suggestions,
      suggestionsVisible = _ref.suggestionsVisible,
      suggestionsLoading = _ref.suggestionsLoading;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      showSuggestions = _useState2[0],
      setShowSuggestions = _useState2[1];

  var filterString = useRef();

  var onInput = function onInput(e) {
    var value = e.currentTarget.value;
    onChange(value);

    if (value && suggestionsVisible) {
      setShowSuggestions(true);
    }
  };

  useOnClickOutside(filterString, function () {
    setShowSuggestions(false);
  });
  return React.createElement(FilterStringWrapper, {
    ref: filterString
  }, React.createElement(Input, {
    "data-testid": "filter-value-input",
    variant: "solid",
    value: value,
    onChange: onInput,
    placeholder: stringPlaceholder
  }), React.createElement(FilterSuggestions, {
    suggestionsLoading: suggestionsLoading,
    suggestionsVisible: showSuggestions,
    suggestions: suggestions,
    filterValue: value,
    onSelect: function onSelect(value) {
      if (value) {
        onChange(value);
      }

      setShowSuggestions(false);
    }
  }));
};

export default FilterString;